<template>
  <v-dialog
    v-model="opened"
    content-class="add-employees"
    max-width="400"
    persistent
  >
    <h3 class="add-employees__title">
      {{ title }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form
      ref="addEmployee"
      class="mt-5"
      :class="{ 'disabled-area': !$can('employee_edit') }"
      @submit.prevent="item ? onUpdate() : onCreate()"
    >
      <v-text-field
        v-model="formData.name"
        outlined
        dense
        :label="$t('common.fields.investorFullName')"
        :rules="[isRequired]"
      />
      <v-text-field
        v-model="formData.phone"
        outlined
        dense
        :label="$t('common.fields.phone')"
        :rules="[isRequired, isPhone]"
      />
      <v-text-field
        v-model="formData.email"
        outlined
        dense
        :label="$t('common.fields.email')"
        :rules="[isRequired, isEmail]"
      />
      <v-text-field
        v-if="!item"
        v-model="formData.password"
        outlined
        dense
        :type="passwordVisible ? 'text' : 'password'"
        :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
        :label="$t('common.fields.password')"
        :rules="[isRequired]"
        @click:append="passwordVisible = !passwordVisible"
      />
      <v-select
        v-model="formData.role"
        outlined
        dense
        item-value="id"
        item-text="displayName"
        :loading="filtersLoading"
        :label="$t('employees.role')"
        :items="roles"
        :rules="[isRequired]"
      />
      <v-select
        v-model="formData.parks"
        outlined
        dense
        item-value="id"
        item-text="name"
        :loading="filtersLoading"
        :label="$t('employees.park')"
        :items="parks"
        :rules="[isRequired]"
        multiple
        chips
        small-chips
        deletable-chips
      />

      <v-btn
        v-if="$can('employee_edit')"
        class="mt-1"
        type="submit"
        color="warning"
        elevation="0"
        block
        :loading="loading"
      >
        Сохранить
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data: () => ({
    loading: false,
    filtersLoading: false,
    passwordVisible: false,
    formData: {
      name: '',
      phone: '',
      email: '',
      password: '',
      role: '',
      parks: [],
    },
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.$emit('close');
        this.$refs.addEmployee.reset();
        this.loading = false;
      }
    },
    item(val) {
      if (val) this.fillForm();
    },
  },
  computed: {
    ...mapState({
      roles: ({ roles }) => roles.list,
      parks: ({ parks }) => parks.list,
    }),
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    title() {
      if (!this.$can('employee_edit') && this.item) return this.item.user.name;
      return this.item ? this.$t('common.btns.edit') : this.$t('employees.add');
    },
  },
  methods: {
    isRequired(v) {
      return (
        !!String(v).length || this.$t('common.fields.validation.field.required')
      );
    },
    isEmail(v) {
      return (
        /(^$|^(([^<>()[\]\\.,;:а-яА-Я\s@"]+(\.[^<>()[\]\\.,;а-яА-Я:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/.test(
          v,
        ) || this.$t('common.fields.validation.email')
      );
    },
    isPhone(v) {
      return (
        /^[+][0-9]{9,12}$/.test(v) || this.$t('common.fields.validation.phone')
      );
    },
    fillForm() {
      this.formData.name = this.item.user.name || '';
      this.formData.phone = this.item.user.phone || '';
      this.formData.email = this.item.user.email || '';
      this.formData.parks = this.item.parks.map(({ id }) => id);
      this.formData.role = this.item.user.roles[0]?.id;

      this.$refs.addEmployee.resetValidation();
    },
    async onUpdate() {
      const isValid = this.$refs.addEmployee.validate();

      if (!isValid) return;

      this.loading = true;

      const params = { ...this.formData };
      delete params.password;

      const result = await this.$store.dispatch('employees/updateItem', {
        id: this.item.id,
        params,
      });

      this.$emit('updated', result);
      this.loading = false;
    },
    async onCreate() {
      const isValid = this.$refs.addEmployee.validate();

      if (!isValid) return;

      this.loading = true;

      const result = await this.$store.dispatch(
        'employees/addNew',
        this.formData,
      );

      this.$emit('updated', result);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.add-employees {
  padding: 10px;
  background-color: #fff;

  &__title {
    font-size: 18px;
    color: #424242;
    text-align: center;
  }
}
</style>
